'use strict';

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.js');
var analytics = require('analytics');
var beacon = require('./beacon.js');
var page = require('./page.js');
var track = require('./track.js');
var identify = require('./identify.js');
var index = require('./EventRegistry/eventSchemas/index.js');

var _excluded = ["metrics_endpoint", "publisherId", "context"],
  _excluded2 = ["id"],
  _excluded3 = ["id"];
var analyticsPluginPico = function analyticsPluginPico(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }
  var _ref2 = _ref,
    _ref2$metrics_endpoin = _ref2.metrics_endpoint,
    metrics_endpoint = _ref2$metrics_endpoin === void 0 ? null : _ref2$metrics_endpoin,
    _ref2$publisherId = _ref2.publisherId,
    publisherId = _ref2$publisherId === void 0 ? null : _ref2$publisherId,
    _ref2$context = _ref2.context,
    context = _ref2$context === void 0 ? 'gadget' : _ref2$context,
    options = _rollupPluginBabelHelpers.objectWithoutPropertiesLoose(_ref2, _excluded);
  return {
    name: 'analytics-plugin-pico',
    config: Object.assign({
      context: context,
      publisherId: publisherId,
      eventSchemas: index,
      send: beacon(metrics_endpoint)
    }, options),
    track: track,
    identify: identify,
    page: page,
    loaded: function loaded() {
      return true;
    },
    methods: {
      guest: function guest(_ref3) {
        if (_ref3 === void 0) {
          _ref3 = {};
        }
        var _ref4 = _ref3,
          id = _ref4.id,
          traits = _rollupPluginBabelHelpers.objectWithoutPropertiesLoose(_ref4, _excluded2);
        this.instance.storage.setItem(analytics.CONSTANTS.ANON_ID, id);
        this.instance.storage.setItem(analytics.CONSTANTS.USER_TRAITS, traits);
      },
      user: function user(_ref5) {
        if (_ref5 === void 0) {
          _ref5 = {};
        }
        var _ref6 = _ref5,
          id = _ref6.id,
          traits = _rollupPluginBabelHelpers.objectWithoutPropertiesLoose(_ref6, _excluded3);
        this.instance.storage.setItem(analytics.CONSTANTS.USER_ID, id);
        this.instance.storage.setItem(analytics.CONSTANTS.USER_TRAITS, traits);
      },
      initPublisher: function initPublisher(publisher_id) {
        // check the code in standardPayload; this handles when a user
        // changes their publisher, so the publisherId stored in the
        // config above is not longer the correct one.
        this.instance.storage.setItem('publisherId', publisher_id);
      }
    }
  };
};
var analyticsPluginPico$1 = analyticsPluginPico;

module.exports = analyticsPluginPico$1;
//# sourceMappingURL=index.js.map
